export const DIGITAL_SERVICING_CONTEXT = 'DIGITAL_SERVICING';
export const VIEW_PAYMENT_DETAILS_CONTEXT = 'VIEW_PAYMENT_DETAILS';
export const HELP_CONTEXT = 'HELP';
export const HOME_PAGE_CONTEXT = 'HOME_PAGE';
export const MANAGE_PAYEE_CONTEXT = 'MANAGE_PAYEE';
export const REQUEST_PAYMENT_CONTEXT = 'REQUEST_PAYMENT';
export const CHOOSE_PRODUCT_CONTEXT = 'CHOOSE_PRODUCT';
